export interface Language {
  code: string;
  name: string;
  emoji: string;
  displayName: string;
}

export const SUPPORTED_LANGUAGES: Language[] = [
  {
    code: "multi",
    name: "Multi-language",
    emoji: "🌍",
    displayName: "🌍 Multi-language",
  },
  {
    code: "en-US",
    name: "English (US)",
    emoji: "🇺🇸",
    displayName: "🇺🇸 English (US)",
  },
  {
    code: "es",
    name: "Spanish",
    emoji: "🇪🇸",
    displayName: "🇪🇸 Spanish",
  },
  {
    code: "en-GB",
    name: "English (UK)",
    emoji: "🇬🇧",
    displayName: "🇬🇧 English (UK)",
  },
  {
    code: "en-AU",
    name: "English (Australia)",
    emoji: "🇦🇺",
    displayName: "🇦🇺 English (Australia)",
  },
  {
    code: "en",
    name: "English",
    emoji: "🇺🇸",
    displayName: "🇺🇸 English",
  },
  {
    code: "fr",
    name: "French",
    emoji: "🇫🇷",
    displayName: "🇫🇷 French",
  },
  {
    code: "fr-CA",
    name: "French (Canada)",
    emoji: "🇨🇦",
    displayName: "🇨🇦 French (Canada)",
  },
  {
    code: "pt",
    name: "Portuguese",
    emoji: "🇵🇹",
    displayName: "🇵🇹 Portuguese",
  },
  {
    code: "pt-BR",
    name: "Portuguese (Brazil)",
    emoji: "🇧🇷",
    displayName: "🇧🇷 Portuguese (Brazil)",
  },
  {
    code: "it",
    name: "Italian",
    emoji: "🇮🇹",
    displayName: "🇮🇹 Italian",
  },
];

export const DEFAULT_LANGUAGE = "en-US";

export const getLanguageByCode = (code: string): Language | undefined => {
  return SUPPORTED_LANGUAGES.find((lang) => lang.code === code);
};

export const getLanguageDisplayName = (code: string): string => {
  const language = getLanguageByCode(code);
  return language ? language.displayName : code;
};
